module.exports = __webpack_public_path__ + "img/bianca.29177128.jpeg";